  function getCookie(name) {
                  let value = "; " + document.cookie;
                  let parts = value.split("; " + name + "=");
                  if (parts.length === 2) return parts.pop().split(";").shift();
              }
  $(window).on('load resize scroll', function () {
    var ah= $('.announcement-bar').outerHeight()+'px';
  $('body').css('top',ah);
            let cookieValue = getCookie('cookieconsent_status');
        if($('.stickybar').length >0 && cookieValue != 'dismiss'){
           if($('div[aria-label="cookieconsent"]').length == 0){
          var interval= setInterval(function(){
            if($('div[aria-label="cookieconsent"]').length >0){
              var h= $('div[aria-label="cookieconsent"]').outerHeight();
             $('.stickybar').css("bottom",h);
              var sh = $('.stickybar').outerHeight() + h;
              $('button.needsclick:not(.klaviyo-close-form)').css("bottom",sh);
              clearInterval(interval);
            }
          },500);
             var sh = $('.stickybar').outerHeight();
          $('button.needsclick:not(.klaviyo-close-form)').css("bottom",sh);
           }
          else{
           var h= $('div[aria-label="cookieconsent"]').outerHeight();
             $('.stickybar').css("bottom",h);
              var sh = $('.stickybar').outerHeight() + h;
              $('button.needsclick:not(.klaviyo-close-form)').css("bottom",sh);
          }
       
        }else if($('.stickybar').length >0 && cookieValue == 'dismiss'){
          var sh = $('.stickybar').outerHeight();
          $('button.needsclick:not(.klaviyo-close-form)').css("bottom",sh);
        }
        else{
          
          if(cookieValue != 'dismiss'){
          if($('div[aria-label="cookieconsent"]').length == 0){
          var interval= setInterval(function(){
            if($('div[aria-label="cookieconsent"]').length >0){
              var h= $('div[aria-label="cookieconsent"]').outerHeight();
              $('button.needsclick:not(.klaviyo-close-form)').css("bottom",h);
              clearInterval(interval);
              console.log('here');
            }
          },500);
           }
          else{
            var h= $('div[aria-label="cookieconsent"]').outerHeight();
              $('button.needsclick:not(.klaviyo-close-form)').css("bottom",h);
          }
  
          }else{
            $('button.needsclick:not(.klaviyo-close-form)').css("bottom",0);
          }
        } 
        });
$(document).ready(function(){

 $(document).on('click','.cc-dismiss',function(){
  $('body').removeClass('cookie-consent-active');
       if($('.stickybar').length >0 ){
         $('.stickybar').css("bottom",0);
          var sh = $('.stickybar').outerHeight();
        $('button.needsclick:not(.klaviyo-close-form)').css("bottom",sh);
       }else{
         $('button.needsclick:not(.klaviyo-close-form)').css("bottom",0);
       }
  });
  
    // new pdp footer spacing on bottom
    
    setTimeout(function () {
      var activeOfferAllPage = $('button.needsclick.kl-teaser-Sekqpn.undefined.kl-private-reset-css-Xuajs1').height();
      $('body').css('padding-bottom', activeOfferAllPage);
//       if($('.rc-radio__input[value="subscription"]:checked').length >0){
//   $('.rc-subscription-details').not('.stickybar .rc-subscription-details').attr('style',"display:block !important");
// }
    }, 8000);

    let videos = document.querySelectorAll('.pdp_right_item video')
        videos.forEach(item=>{
            let newThumbnail = item.getAttribute('poster'); 
            if (newThumbnail.includes('_small')){ 
                newThumbnail = newThumbnail.replace('_small',''); 
                item.setAttribute('poster', newThumbnail)
            }
        });

  if(window.location.href.indexOf('cartdrawer') >-1){
   // window.location.href.split('?')[0];
    $('.cart-link').trigger('click');
    history.pushState({}, "", window.location.href.split('?')[0]);
}
// On Change Variant Show the variant metafield Text START CODE
  function updateHiddenSelect(value) {
        var $hiddenSelect = $('#hidden_var');
        var $option = $hiddenSelect.find('option[value="' + value + '"]');
        if ($option.length) {
            $hiddenSelect.val($option.val());
            var priceOunce = $option.attr('price_ounce');
            var $existingPriceSpan = $('.price-ounce-info');
            if (priceOunce && priceOunce.trim() !== '') {
                if ($existingPriceSpan.length === 0) {
                    var $priceSpan = $('<span></span>').text(priceOunce).addClass('price-ounce-info');
                    $('.product__price').after($priceSpan);
                } else {
                    $existingPriceSpan.text(priceOunce);
                }
            } else {
                if ($existingPriceSpan.length > 0) {
                    $existingPriceSpan.remove();
                }
            }
        } else {
            $('.price-ounce-info').remove();
        }
    }
    function initializeDisplay() {
        var $selectedRadio = $('.variant-input input[type="radio"]:checked');
        if ($selectedRadio.length) {
            var selectedValue = $selectedRadio.val();
            updateHiddenSelect(selectedValue);
        } else {
            var $firstRadio = $('.variant-input input[type="radio"]:first');
            if ($firstRadio.length) {
                var firstValue = $firstRadio.val();
                updateHiddenSelect(firstValue);
            }
        }
    }
   initializeDisplay();
    $(document).on('change', '.variant-input input[type="radio"]', function() {
        var selectedValue = $(this).val();
        console.log('Radio button changed to:', selectedValue);
        updateHiddenSelect(selectedValue);
    });
  // On Change Variant Show the variant metafield Text END CODE

// Open Chat box on contact page START
    window.addEventListener('load', function() {
  if ($(window).width() < 768) {
var initGorgiasChatPromise = (window.GorgiasChat) 
    ? window.GorgiasChat.init() 
    : new Promise(function (resolve) { 
        window.addEventListener('gorgias-widget-loaded', function () { 
            resolve(); 
        });
    });

initGorgiasChatPromise.then(function() {
    // Function to check the chat status and hide the button if necessary
    function checkChatStatus() {
        var chatButton = document.getElementById('chat-button');
        if (chatButton) {
            if (!GorgiasChat.isOpen()) {
                chatButton.style.display = 'none';
            }
        }
    }
    checkChatStatus();
    if (!GorgiasChat.isOpen()) {
        setInterval(checkChatStatus, 1000); 
    }
});


  $('.menu_chat').click(function(){
      $('#chat-button').show();
});
  }
      });
if (window.location.href.indexOf('/pages/contact') > -1) {
  window.addEventListener('load', function() {
    setTimeout(function() {
      if (typeof GorgiasChat !== 'undefined') {
        GorgiasChat.open();
      }
    }, 3000);
  });
}
  // Open Chat box on contact page END



  
if($('.FreeProductId').length > 0){
$('.FreeProductId').each(function(index){
 $.ajax({
                method: "POST",
                dataType: 'json',
                url: "/cart/change.js",
                async: false,
                data:{'id': $(this).val(), 'quantity':0 },
                success: function(data) {
                    console.log(data);
                  if(index == ($('.FreeProductId').length -1)){
                     document.dispatchEvent(new CustomEvent('cart:build'));
                  }
                },
             error:function(response){
               console.log(response.responseJSON.description);
              
             }
           });
   
  })
}

  // Add class on based Footer Cookies based START CODE
 function getCookie(name) {
                let value = "; " + document.cookie;
                let parts = value.split("; " + name + "=");
                if (parts.length === 2) return parts.pop().split(";").shift();
            }

 
 function updateBodyClass() {
     let cookieValue = getCookie('cookieconsent_status');
                if (cookieValue == 'dismiss') {
                    $('body').removeClass('cookie-consent-active');
                   clearInterval(interval);
                }else{
                  if($('div[aria-label="cookieconsent"]').length >0){
                   $('body').addClass('cookie-consent-active');
                   clearInterval(interval);
                  }
                }
                 
                
    
            }
            updateBodyClass();
            var interval=setInterval(updateBodyClass, 1000);
  
  // Add class on based Footer Cookies based  END CODE

  // Addon Products and Quantity Addon START
document.querySelectorAll('.quick-product__btn').forEach(button => {
    button.addEventListener('click', () => {
        setTimeout(() => {
            $('.addon_item_togle input').click(function() {

            var $this = $(this);
            var $addonItem = $this.parents('.addon_item');
            
            $addonItem.toggleClass('active_addon');
       $addonItem.addClass('show_text');
            
            if ($addonItem.hasClass('active_addon')) {
                var $addedText = $addonItem.find('.added_text');
                $addedText.show();
                
                setTimeout(function() {
                    $addedText.fadeOut();
                      $addonItem.removeClass('show_text');
                }, 1000); // Hide text after 3 seconds
            }
        });
        }, 5000); // Adjust delay based on loading time
    });

});
  $('.pdp_quantity_image').click(function() {
        var input = $(this).prev('input[type="radio"]');
        input.prop('checked', true).trigger('change');
        $('.quantity1 input[type="radio"]').not(input).prop('checked', false);
    var quantity_heading=($(input).attr('quantity'));
     $('.quantity_heading').text('Quantity ' + quantity_heading);
    });
  
    $('.addon_item_togle input').click(function() {
      debugger;
            var $this = $(this);
            var $addonItem = $this.parents('.addon_item');
            
            $addonItem.toggleClass('active_addon');
       $addonItem.addClass('show_text');
            
            if ($addonItem.hasClass('active_addon')) {
                var $addedText = $addonItem.find('.added_text');
                $addedText.show();
                
                setTimeout(function() {
                    $addedText.fadeOut();
                      $addonItem.removeClass('show_text');
                }, 1000); // Hide text after 3 seconds
            }
        });

window.upcartOnAddToCart = function(item) {
  console.log("Item added to cart:", item);
    var combo_product_data=[];
    if($('.addon_item_togle input:checked').length >0 || $('.quantity1 input:checked').length > 0 ){
   $('.addon_item_togle input:checked').each(function(){
         var items1 = {};
     var variant_id =$(this).val();
        items1['id'] = $.trim(variant_id);
    items1['quantity'] = 1;
    combo_product_data.push(items1);
     });
       var selling_id=0;
      $('.quantity1 input:checked').each(function(){
        var quantity = $(this).attr('quantity');
       console.log(quantity);
         var items1 = {};
     var variant_id =$(this).parents('.product-single__meta').find('select.product-single__variants option:selected').val();
        if($('.rc-radio-group__options input[data-radio-subsave]:checked').length >0){
         selling_id=$('.rc_widget__option__plans__dropdown option:selected').val();
        }
        items1['id'] = $.trim(variant_id);
    items1['quantity'] = quantity - 1;
        if(selling_id != 0){
         items1['selling_plan'] = selling_id; 
        }
    combo_product_data.push(items1);
     });   
    console.log(combo_product_data);
  $.ajax({
                method: "POST",
                dataType: 'json',
                url: "/cart/add.js",
                async: false,
                data:{items:combo_product_data},
                success: function(data) {
                    console.log(data);
                  
                },
             error:function(response){
               console.log(response.responseJSON.description);
              
             }
           });
    }
 
};
    // Addon Products and Quantity Addon END
  
$(".badge_image_container p span, .pdp_video_popup").on('click', function() {
  $(".custom-model-main").addClass('model-open');
  $("body").addClass('open_popup');
}); 
 $(".close-btn").click(function(){
                $(".custom-model-main").removeClass('model-open');
    $("body").removeClass('open_popup');
            });

 $(document).mouseup(function(e) {
                var container = $(".custom-model-inner");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                   $(".custom-model-main").removeClass('model-open');
                  $("body").removeClass('open_popup');
                }
            });
  


 setInterval(function() {
    $("span.stamped-badge-caption").each(function(){
      var reviewcount = $(this).attr("data-reviews");
      $(this).text("("+reviewcount+")");
    });
  }, 2500);
   setInterval(function() {
    $(".new-pdp-template span.stamped-badge-caption").each(function(){
      var reviewcount = $(this).attr("data-reviews");
      $(this).text(""+reviewcount+" Reviews");
    });
  }, 2500);
  setInterval(function() {
    $(".new-pdp-template-2 span.stamped-badge-caption").each(function(){
      var reviewcount = $(this).attr("data-reviews");
      $(this).text("("+reviewcount+" Reviews)");
    });
  }, 2500);
  
  
       if(window.location.href.indexOf('products') > -1){
      
    //      if ($('body').hasClass('template-product') && !$('body').hasClass('new-pdp-template')) {
    //            $('.fisrt-collapsible-content:first').addClass('is-open');
    // $('.fisrt-collapsible-content:first').addClass('is-open');
    // $(".fisrt-collapsible-content:first").attr("aria-expanded","true");
    //  $(".fisrt-collapsible-content:first").css('height','auto');
    // }

         $.fn.isOnScreen2 = function() {
  var win = $(window);
  var viewport = {
    top: win.scrollTop() + $('.site-header').outerHeight() || 0,
    left: win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  if (!bounds) return false; // Ensure bounds exist
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return (
    viewport.right >= bounds.left &&
    viewport.left <= bounds.right &&
    viewport.bottom >= bounds.top &&
    viewport.top <= bounds.bottom
  );
};

if ($('.product-block button.btn.btn--full.add-to-cart').length > 0) {
  let isScrollEventAttached = false;

  function inViewport2() {
    if ($(".main_template button.btn.btn--full.add-to-cart").isOnScreen2()) {
      $('.sticky_main-container').hide();
    } else {
      $('.sticky_main-container').show();
    }
  }

  if (!isScrollEventAttached) {
    isScrollEventAttached = true; // Prevent duplicate listeners
    document.addEventListener('scroll', inViewport2);
  }
}
}
$(document).on('change', '.variant-input', function() {
    var val = $(this).attr('data-value');
    $('.sticky_main-container .price_wrape').html($('.main_template .product-block.product-block--price .price_wrape').html());
    var isSticky = $(this).parents('.container').hasClass('sticky_main-container');
    var targetInput = isSticky 
        ? '.main_template .variant-input input[value="'+val+'"]' 
        : '.sticky_main-container .variant-input input[value="'+val+'"]';
    $(targetInput).trigger('click');

  setTimeout(function() {
    var selling_id = $('.main_template input[name="selling_plan"]').val(); // Get the updated selling plan value
    console.log(selling_id); // Print the updated selling plan value to the console

    // Update the sticky form with the new selling plan value
    $('.sticky_main-container .product-single__form input[name="selling_plan"]').val(selling_id);
  }, 100);

});

  $(document).on('change','.rc-template__button-group .rc-radio input',function(){
 var vales =  $.trim($(this).attr('value'));
    if($(this).parents('.container').hasClass('sticky_main-container')){
        $(`.rc-template__button-group  .rc_widget__option--${vales}`).trigger('click');
    }else{
        $(`.sticky_main-container .rc-template__button-group  .rc_widget__option--${vales}`).trigger('click') 
    }
});


  
    var $root = $('html, body');
    var ancloc = window.location.hash;
      if(ancloc !=''){
        $root.animate({
            scrollTop: $(ancloc).offset().top
        }, 1000, function () {
            window.location.hash = href;
        });
        return false;
      }
  });
document.addEventListener("DOMContentLoaded", function () {
    let lastSwipedElement = null; // Store the last swiped element

    document.querySelectorAll(".grid-product__image-link").forEach((link) => {
        let startX = 0, startY = 0;
        let isSwiped = false;

        // Ensure primary image is shown when navigating back
        link.classList.remove("active");

        // Check if the device supports touch (mobile only)
        if (window.matchMedia("(max-width: 768px)").matches && navigator.maxTouchPoints > 0) {
            // Detect touch start position
            link.addEventListener("touchstart", function (event) {
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
                isSwiped = false;
            });

            // Detect touch move and determine swipe direction
            link.addEventListener("touchmove", function (event) {
                let moveX = event.touches[0].clientX;
                let moveY = event.touches[0].clientY;
                let diffX = startX - moveX;
                let diffY = startY - moveY;

                if (Math.abs(diffX) > 30 || Math.abs(diffY) > 30) { // Minimum swipe distance
                    event.preventDefault(); // Prevent accidental navigation

                    // Reset the previous swiped product image
                    if (lastSwipedElement && lastSwipedElement !== this) {
                        lastSwipedElement.classList.remove("active");
                    }

                    // Show secondary image for the current product
                    this.classList.add("active");
                    lastSwipedElement = this; // Update last swiped element
                    isSwiped = true;
                }
            });
        }

        // Handle click - only navigate if there was NO swipe
        link.addEventListener("click", function (event) {
            if (isSwiped) {
                event.preventDefault(); // Stop navigation if swiped
            } else {
                event.preventDefault();
                this.classList.add("active"); 
                setTimeout(() => {
                    window.location.href = this.href;
                }, 150);
            }
        });
    });
    window.addEventListener("pageshow", function () {
        document.querySelectorAll(".grid-product__image-link").forEach((link) => {
            link.classList.remove("active"); // Reset images to primary
        });
        lastSwipedElement = null; // Clear last swiped element on page reload
    });
});